import About from './about.js';

export default About;
